/** @jsxImportSource @emotion/react */

import "./index.css";

import { Drawer } from "antd";
import { ReactComponent as CloseDrawIcon } from "assets/mobile/icons/close-draw.svg";
import { ReactComponent as BackIcon } from "assets/mobile/icons/reply-solid.svg";
import Container from "components/common/Container";
import { CSSProperties } from "react";

import { MDrawerStyle } from "./index.style";

interface MDrawerProps {
  isOpen?: boolean;
  onClose?: () => void;
  title?: string;
  className?: string;
  children?: React.ReactNode;
  bodyStyle?: CSSProperties;
  isBack?: boolean;
  onBack?: () => void;
}

const MDrawer = (props: MDrawerProps) => {
  const {
    isOpen,
    onClose,
    title,
    children,
    bodyStyle,
    isBack,
    onBack,
    className,
  } = props;

  const handleClose = () => {
    onClose && onClose();
  };

  const handleBack = () => {
    onBack && onBack();
  };

  return (
    <div css={MDrawerStyle.self}>
      <Drawer
        className={className}
        title={
          <Container>
            <div css={MDrawerStyle.headerWrapper}>
              <div css={MDrawerStyle.header}>
                {isBack && (
                  <BackIcon css={MDrawerStyle.backIcon} onClick={handleBack} />
                )}
                <h1 css={MDrawerStyle.title}>{title}</h1>
                {<CloseDrawIcon onClick={handleClose} />}
              </div>
            </div>
          </Container>
        }
        headerStyle={{ padding: "0", backgroundColor: "black" }}
        placement="bottom"
        closable={false}
        onClose={handleClose}
        open={isOpen}
        height="calc(100% - 45px)"
        bodyStyle={
          bodyStyle || {
            backgroundColor: "white",
            padding: "16px",
            marginTop: "-30px",
            paddingTop: "50px",
          }
        }
      >
        {children}
      </Drawer>
    </div>
  );
};

export default MDrawer;
